// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../node_modules/css-loader/dist/cjs.js?{\"sourceMap\":true}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2b086fd6\",\"scoped\":false,\"hasInlineConfig\":true}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":true}!./pageView-clientCare.less");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../node_modules/vue-style-loader/lib/addStylesClient.js")("9d4f2632", content, false, {});
// Hot Module Replacement
if(module.hot) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/dist/cjs.js?{\"sourceMap\":true}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2b086fd6\",\"scoped\":false,\"hasInlineConfig\":true}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":true}!./pageView-clientCare.less", function() {
     var newContent = require("!!../../../node_modules/css-loader/dist/cjs.js?{\"sourceMap\":true}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2b086fd6\",\"scoped\":false,\"hasInlineConfig\":true}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":true}!./pageView-clientCare.less");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-style-loader!./node_modules/css-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2b086fd6","scoped":false,"hasInlineConfig":true}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":true}!./src/style/pageStyle/pageView-clientCare.less
// module id = cL9i
// module chunks = 1